import LtiIntegration from 'pages/integrations/containers/LtiIntegrationContainer/components/ltiIntegration';
import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ltiActions } from 'pages/integrations/containers/LtiIntegrationContainer/actions';
import { piiSharingActions } from 'pages/integrations/containers/LtiIntegrationContainer/piiSharing/actions';

const LtiConfiguration = ({ dispatch }) => {
  useEffect(() => {
    dispatch(ltiActions.fetchLtiConfigurations());
    dispatch(piiSharingActions.fetchPiiSharingConfigs());
  }, [dispatch]);

  return <LtiIntegration />;
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(ltiActions, dispatch)
  };
}
export default connect(mapDispatchToProps)(LtiConfiguration);
